module.exports = __webpack_public_path__ + "static/media/b5-江南第一茶楼.d475c264.png";